import React, { useEffect, useState } from "react";

const browserKeys = [
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
  ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
  ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
  ["Z", "X", "C", "V", "B", "N", "M", "←"],
  ["AC", "SPACE", "削除"],
];

/**
 * キーボードコンポーネント
 * @param {string} defaultValue 初期値
 * @param {Function} onChange キー押下時の処理
 * @class KeyPad
 */
export default function KeyPad({ defaultValue, onChange }) {
  const [text, setText] = useState("");

  /**
   * 入力欄のテキストが変更されたら、その変更を反映する
   * @memberof KeyPad
   */
  useEffect(() => {
    onChange(text);
  }, [text, onChange]);
  /**
   * 初期値が指定されていれば、入力欄に反映する
   * @memberof KeyPad
   */
  useEffect(() => {
    setText(defaultValue);
  }, [defaultValue]);
  /**
   * キーボードが押下されたら、入力欄のテキストに追加する
   * @param {string} key 押下されたキーボードの値
   * @memberof KeyPad
   */
  const onClick = (key) => {
    if (`${key}`.match(/^[0-9A-Z-]{1}$/g) !== null) {
      setText(`${text}${key}`);
    } else if (key.match(/^ac$/gi) !== null) {
      setText("");
    } else if (key.match(/^space$/gi) !== null) {
      setText(`${text} `);
    } else {
      setText(text.slice(0, -1));
    }
  };

  return (
    <>
      <div className="key-pad-container">
        {browserKeys.map((rows) => (
          <div className="key-row">
            {rows.map((key) => (
              <button
                key={`key${key}`}
                className={`${["←", "AC", "削除"].includes(key) ? "sub" : ""} ${key === "SPACE" ? "wide" : ""}`}
                onClick={() => onClick(key)}
              >
                {key}
              </button>
            ))}
          </div>
        ))}
      </div>
    </>
  );
}
